import * as actions from "Actions";
import * as api from "Api";

export const fetchComments = ({ limit = 20, objectType, objectId }) => (
  dispatch,
  getState
) => {
  const { auth } = getState();
  const { token, navCommunity } = auth;

  return dispatch(
    actions.fetchComments(
      api.fetchComments({
        token,
        limit,
        objectType,
        objectId,
        organizationId: navCommunity ? navCommunity.id : null
      })
    )
  );
};

export const saveComment = ({ objectType, objectId, comment } = {}) => (
  dispatch,
  getState
) => {
  const { token, navCommunity } = getState().auth;
  return dispatch(
    actions.saveComment(
      api.saveComment({
        token,
        objectType,
        objectId,
        comment,
        organizationId: navCommunity.id
      })
    )
  );
};

// export const fetchInfiniteAlbums = ({ limit, offset } = {}) => (
//   dispatch,
//   getState
// ) => {
//   const { lng } = getState().params;
//   const { auth, filter } = getState();
//   const { token, navCommunity } = auth;

//   return dispatch(
//     actions.fetchInfiniteAlbums(
//       api.getAlbums({
//         token,
//         limit,
//         offset,
//         lng,
//         filterBy: filter.filterState,
//         community: navCommunity /*, sourceToken*/
//       })
//     )
//   );
// };



// WEBPACK FOOTER //
// ./src/actions/thunks/comment.js